import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router } from '@angular/router';
import { AppState } from '../../app.service';
import { PermissionService } from "./permission.service";
import { Observable } from "rxjs/Observable";
import { Observer } from "rxjs/Observer";

@Injectable()
export class BaseGuard implements CanActivate, CanActivateChild {

    constructor(
        private basePermissionService: PermissionService,
        private permissionName: string,
        private baseRouter: Router,
        private baseAppState: AppState
    ) {
    }

    private activate(route: ActivatedRouteSnapshot): Observable<boolean> {
        let self: BaseGuard = this;
        return new Observable<boolean>(observer => {
            if (self.basePermissionService.permissionNames.length) {
                self.activateCheck(observer);
            } else {
                self.basePermissionService
                    .getPermissions(observer)
                    .subscribe(() => self.activateCheck(observer));
            }
        });
    }

    private activateCheck(observer: Observer<boolean>): void {
        let hasPermission: boolean = this.basePermissionService.userHasPermission(this.permissionName);
        let loggedIn: boolean = this.baseAppState.isLoggedIn();
        if (!hasPermission || !loggedIn) {
            this.baseRouter.navigate(['/account/login']);
        }
        observer.next(hasPermission && loggedIn);
    }

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.activate(route);
    }

    public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.activate(childRoute);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/services/SecurityServices/base.guard.ts